import supabaseClient from "@/api/supabaseClient";
import { useMutation } from "@tanstack/react-query";
import type { UpdateItineraryCodySuggestionPayload } from "$/requests/UpdateItineraryCodySuggestionRequest.ts";
import type { Itinerary } from "$/models/Itinerary.model.ts";
import { queryClient } from "@/main.tsx";
import invokeRefinement from "@/api/itineraries/invokeRefinement.ts";

const useRefineTripCodySuggestion = () => {
  const client = supabaseClient;

  const mutationFn = async (request: UpdateItineraryCodySuggestionPayload) =>
    invokeRefinement(client, "refine_trip_cody_suggestion", request);

  return useMutation({
    mutationFn,
    retry: false,
    onSuccess: (result) => {
      if (result.outcome !== "changed") return;

      const updatedItinerary = result.itinerary;

      queryClient.setQueriesData<Itinerary[]>(
        { queryKey: ["itineraries"] },
        (cached) =>
          cached?.map((itinerary) =>
            itinerary.id === updatedItinerary.id ? updatedItinerary : itinerary,
          ),
      );
      void queryClient.invalidateQueries({ queryKey: ["itineraries"] });
      void queryClient.invalidateQueries({ queryKey: ["user"] });
      void queryClient.invalidateQueries({ queryKey: ["places"] });
    },
  });
};

export default useRefineTripCodySuggestion;
